import React, {Component} from 'react';
import { observer } from 'mobx-react';
import EditModal from "./components/EditModal";
import ExtendedPopup from "./components/ExtendedPopup";

import "./PopupContainer.css";

@observer
class PopupContainer extends Component {
    render() {
        if (!this.props.isMobile) {
            if (this.props.appStore.pendingState.element.icon.type === 'icon') {
                return (
                    <div className="PopupContainer">
                        <ExtendedPopup position={this.props.appStore.pendingState.element.position}>
                            <EditModal appStore={this.props.appStore}/>
                        </ExtendedPopup>}
                    </div>
                )
            } else {
                return (
                    <div className="PopupContainer fixed">
                        <EditModal appStore={this.props.appStore}/>
                    </div>
                )
            }
        } else {
            return (
                <div className="PopupContainer">
                    <EditModal appStore={this.props.appStore}/>
                </div>
            )
        }
    }

}

export default PopupContainer;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/PopupContainer/index.js